var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.warningZone)?_c('div',{staticClass:"auto-logout-modal"},[_c('div',{staticClass:"alert alert-warning text-center",attrs:{"role":"alert"}},[_vm._v(" "+_vm._s(_vm.$t("autoLogout"))+" ")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }